import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Métodos de pago',
  payment_options: {
    [PaymentMethod.Card]: 'Tarjeta de crédito',
  },
};
